<template>
  <div :class="navbarWrapperClasses">
    <div :class="extraNavClasses">
      <div
        class="nav-menu-icon"
        @click="setIsSidebarOpen(!$store.state.isSidebarOpen)"
      >
        <b-icon icon="list" class="nav-menu-icon" />
      </div>

      <div class="nav-menu-logo">
        <img :src="merchantLogo" />
      </div>
    </div>

    <b-navbar id="main_nav">
      <div class="page-title">
        <h3>{{ pageTitle }}</h3>
      </div>
      <div v-if="multipleMerchants"><MerchantSelector /></div>
    </b-navbar>

    <b-dropdown id="dropdown-1" variant="icon-button" no-caret right size="sm">
      <template #button-content>
        <b-icon icon="person-circle" />
        <div class="sr-only">Profile</div>
      </template>
      <b-dropdown-item><b-icon icon="gear-fill" /> Settings</b-dropdown-item>
      <b-dropdown-item @click="handleLogout">
        <b-icon icon="box-arrow-right" /> Logout
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import MerchantSelector from '@/components/Elements/MerchantSelector/MerchantSelector.vue'

export default {
  name: 'Navbar',
  components: {
    MerchantSelector
  },
  methods: {
    ...mapMutations(['setIsSidebarOpen']),
    handleLogout() {
      this.$store.dispatch('logout').then(res => {
        this.$router.push({ name: 'Login' })
      })
    }
  },
  computed: {
    multipleMerchants() {
      return this.$store.getters.numMerchants > 1
    },
    currentMerchant() {
      return this.$store.getters.currentMerchant
    },
    navbarWrapperClasses() {
      return [
        'h-flex',
        'navbar-wrapper',
        this.$store.state.isSidebarOpen ? 'opened' : 'closed'
      ]
    },
    extraNavClasses() {
      return [
        'h-flex',
        'navbar-extras',
        this.$store.state.isSidebarOpen ? 'opened' : 'closed'
      ]
    },
    merchantLogo() {
      return this.$store.getters.profileMerchantLogo
    },
    pageTitle() {
      return this.$store.getters.pageTitle
    }
  }
}
</script>
